import React from 'react';
import star from '../../../assets/images/circus/star.png';

const CircusStar = () => (
    <img src={star} alt='' />
);

export default CircusStar;
